import React from "react";
import { Box } from "@mui/joy";
import DarkCard from "../../../../common/DarkCard";
import DarkTypography from "../../../../common/DarkTypography";

type ProfileFormSectionProps = {
  title: string;
  children: React.ReactNode;
};

export default function ProfileFormSection({ title, children }: ProfileFormSectionProps) {
  return (
    <DarkCard dense sx={{ maxWidth: "100%" }}>
      <DarkTypography level="title-sm" colorVariant="title" sx={{ mb: { xs: 1.25, sm: 1.5 } }}>
        {title}
      </DarkTypography>
      <Box sx={{ maxWidth: "100%" }}>{children}</Box>
    </DarkCard>
  );
}
